import styled from 'styled-components'
import { Link as GatsbyLink } from "gatsby"
 
const StyledGatsbyLink = styled(GatsbyLink)`


`
 
export default StyledGatsbyLink